// extracted by mini-css-extract-plugin
export default {"tooltip":"OW-z","arrow":"PW-z"};